import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const BuildingEmotionalResilienceSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="building-emotional-resilience"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Life will always include setbacks. Resilience is not avoiding difficulty. It is the ability to
      adapt, update your thinking, and continue moving forward.
    </GuideLead>
    <p className="guide-panel__p">
      Emotionally resilient people still experience disappointment, sadness, fear, and frustration.
      The difference is that they do not remain stuck there.
    </p>
    <GuideSectionLabel>Habits that build emotional resilience</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="awareness"
        title="Accept reality"
        description="You cannot solve a problem you refuse to acknowledge. Acceptance is not giving up — it is beginning from reality."
      />
      <GuideCard iconKey="clarity" title="Focus on what you can control">
        <GuideBlockList
          items={[
            "What can I influence?",
            "What must I accept?",
            "What is my next best action?",
          ]}
        />
      </GuideCard>
      <GuideCard
        iconKey="communication"
        title="Test self-critical thoughts"
        description="Ask: what would I conclude if a colleague reported the same facts about themselves?"
      />
      <GuideCard
        iconKey="growth"
        title="Build strong relationships"
        description="Sharing an interpretation with a trusted person is a fast way to fact-check it."
      />
      <GuideCard iconKey="thinking" title="Learn from every experience">
        <GuideBlockList
          items={[
            "What did I learn?",
            "What response worked, and what evidence did I gather?",
            "How will this help me in the future?",
          ]}
        />
      </GuideCard>
    </GuideCardGrid>
    <GuideCallout variant="amber">Growth often begins with honest reflection.</GuideCallout>
  </GuidePanel>
);

export default BuildingEmotionalResilienceSection;
